export const homeURL = 'https://www.fujienglish.com';